import { withInstall } from '../../../../utils/with-install'
import DistrictCluster from './DistrictCluster.vue'

export const ElAmapLayerDistrictCluster = withInstall(DistrictCluster)
export default ElAmapLayerDistrictCluster
